import { loadLogs, saveLogs } from '../firebase/db-logs';
import {
  loadMaintenanceLogs,
  saveMaintenanceLogs,
} from '../firebase/db-maintenanceLogs';
import {
  createSettingsItem,
  loadSettings,
  saveSettings,
} from '../firebase/db-settings';
import { LogType } from '../interfaces/LogType';
import { MaintenanceLogType } from '../interfaces/MaintenanceLogType';
import { SettingsType } from '../interfaces/SettingsType';
import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.REACT_APP_BACKUP_SECRET_KEY;

export async function createBackup(setStatus: (val: string) => void) {
  if (SECRET_KEY == undefined) {
    setStatus('Encryption Key fehlerhaft');
    return;
  }
  setStatus('Sichere Logs...');
  let allLogs = await loadLogs(undefined, undefined, []);
  if (allLogs == undefined) allLogs = [];
  setStatus('Sichere Einstellungen...');
  let settings = await loadSettings();
  if (settings == undefined) settings = createSettingsItem({});
  setStatus('Sichere Wartunglogs...');
  let maintenanceLogs = await loadMaintenanceLogs();
  if (maintenanceLogs == undefined) maintenanceLogs = [];

  const backupDB: BackupDB = {
    allLogs: allLogs,
    settings: settings,
    maintenanceLogs: maintenanceLogs,
  };

  const jsonString = JSON.stringify(backupDB, null, 2);
  const encryptedData = CryptoJS.AES.encrypt(jsonString, SECRET_KEY).toString();
  const blob = new Blob([encryptedData], { type: 'application/json' });
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = 'backup.encrypted';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);

  URL.revokeObjectURL(url);

  setStatus('Sicherung DB abgeschlossen!');
}

export async function uploadBackupToDB(
  setStatus: (val: string) => void,
  file: File
) {
  if (SECRET_KEY == undefined) {
    setStatus('Encryption Key fehlerhaft');
    return;
  }

  setStatus('Lade Datei hoch...');

  const reader = new FileReader();
  reader.readAsText(file);

  reader.onload = async (event) => {
    try {
      const decryptedData = CryptoJS.AES.decrypt(
        event.target?.result as string,
        SECRET_KEY
      ).toString(CryptoJS.enc.Utf8);
      const backupDB: BackupDB = JSON.parse(decryptedData);
      console.log(backupDB);
      if (
        backupDB.settings &&
        backupDB.allLogs &&
        backupDB.maintenanceLogs &&
        Array.isArray(backupDB.allLogs)
      ) {
        setStatus('Speichere Logs...');
        await saveLogs(backupDB.allLogs);
        setStatus('Speichere Wartungslogs...');
        await saveMaintenanceLogs(backupDB.maintenanceLogs);
        setStatus('Speichere Einstellungen...');
        await saveSettings(backupDB.settings);
        setStatus('Daten erfolgreich in die DB gespeichert!');
      } else {
        setStatus('Fehler: Ungültiges Backup-Format');
      }
    } catch (error) {
      setStatus('Fehler beim Einlesen der Datei');
    }
  };
}

export type BackupDB = {
  allLogs: LogType[];
  maintenanceLogs: MaintenanceLogType[];
  settings: SettingsType;
};
